import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';

export const isSwipeRefreshEnabled = () => isMiniHostAppFeatureEnabled('swipeRefresh');
